import { render, staticRenderFns } from "./OmniAlertInline.vue?vue&type=template&id=1c19845d&"
import script from "./OmniAlertInline.vue?vue&type=script&lang=js&"
export * from "./OmniAlertInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports